export const ACCOUNT_STATUS = {
  PROCESSING: 'Processing',
  SUBMITTED: 'Submitted',
  ACTIVE: 'Active',
  NOT_ACTIVE: 'Not Active',
  IN_REVIEW: 'In Review',
  SUBMITTED_BASE: 'Submitted (Base)',
};

export const INFORMATION_NEEDED_TOGGLES = [
  {
    label: 'Business',
    name: 'hasBusinessPage',
  },
  {
    label: 'Locations',
    name: 'hasLocationsPage',
  },
  {
    label: 'Loans',
    name: 'hasLoansPage',
  },
  {
    label: 'Obligations',
    name: 'hasObligationsPage',
  },
  {
    label: 'People',
    name: 'hasPeoplePage',
  },
  {
    label: 'Vendors',
    name: 'hasVendorsPage',
  },
  {
    label: 'Products',
    name: 'hasProductsPage',
  },
  {
    label: 'Payments',
    name: 'hasPaymentsPage',
  },
  {
    label: 'Documents',
    name: 'hasDocumentsPage',
  },
  {
    label: 'Consents',
    name: 'hasConsentsPage',
  },
  {
    label: 'NDA',
    name: 'ndaNeeded',
  },
  {
    label: 'BG Consent',
    name: 'bgCheckNeeded',
  },
];
